'use client'

import useBlogList from '../../../../core/hook/useBlogList'
import { buildFullUrlMedia } from '../../../../core/hook/utils'
import {
  BLOG_TYPE_THIS_IS_M,
  CmsBlogList,
  PAGE_SIZE_FOR_RUBRIC,
} from '../../../../domain/cmsBlogList'
import { useTranslation } from '../../../context/ConfigContext'
import AnimationEventOnBlogList from './AnimationEventOnBlogList'
import StickyYearOnBlogList from './StickyYearOnBlogList'
import Image from '../../Image/Image'
import Link from '../../Link/Link'

const BlogThisismList = ({ initialData }: { initialData: CmsBlogList }) => {
  const { data, isLoading, fetchNextPage, isLastPage, page } = useBlogList(
    {
      blogType: BLOG_TYPE_THIS_IS_M,
      pageSize: PAGE_SIZE_FOR_RUBRIC[BLOG_TYPE_THIS_IS_M],
    },
    initialData,
  )
  const t = useTranslation()

  return (
    <div className='Blog-list-container'>
      <StickyYearOnBlogList isReady={!isLoading} />
      {data.items.map((item) => (
        <article
          className='Blog-list-item Blog-item with-thisism-item-animation'
          data-year={item.date?.getFullYear() ?? null}
          key={item.id}>
          <div className='Blog-item-wrapper'>
            <Link href={item.url}>
              <div className='Blog-item-image Item--4_3'>
                <div className='content-wrapper content-wrapper-event'>
                  <picture>
                    <Image
                      className='img-responsive'
                      src={buildFullUrlMedia(`/media/${item.image}`)}
                      alt={item.name}
                    />
                  </picture>
                </div>
              </div>
              <div className='Blog-item-info-wrapper'>
                <h2 className='Blog-item-title'>{item.name}</h2>
                <div
                  className='Blog-item-description'
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
            </Link>
          </div>
        </article>
      ))}
      {!isLastPage && (
        <div className='event-page-container-seemore'>
          <a
            href={`?page=${page}`}
            className='button'
            onClick={(e) => {
              e.preventDefault()
              e.nativeEvent.stopImmediatePropagation()
              e.currentTarget.blur()
              fetchNextPage()
            }}>
            <span className='snake' />
            <span className='snake__overlay' />
            {t('See more', {}, false)}
          </a>
        </div>
      )}
      <AnimationEventOnBlogList items={data.items} classNameItem='with-thisism-item-animation' />
    </div>
  )
}

export default BlogThisismList
